// src/components/Card.tsx
import { jsx } from "react/jsx-runtime";
var Card = () => {
  return /* @__PURE__ */ jsx("div", {
    className: "w-24 h-24 bg-green-500",
    children: /* @__PURE__ */ jsx("p", {
      children: "Hello, world!"
    })
  });
};
export {
  Card
};
